import script from "./WithdrawalsView.vue?vue&type=script&setup=true&lang=js"
export * from "./WithdrawalsView.vue?vue&type=script&setup=true&lang=js"

import "./WithdrawalsView.vue?vue&type=style&index=0&id=097feb05&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-097feb05"]])

export default __exports__